// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sync-direction {
  min-height: calc(100vh - 140px);
  padding: 40px;
  background: #f8fafc;
}

.sync-direction-header {
  text-align: center;
  margin-bottom: 50px;
}

.sync-direction-header h1 {
  font-size: 32px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 12px;
}

.sync-direction-header p {
  font-size: 16px;
  color: #6b7280;
  margin-bottom: 8px;
  line-height: 1.6;
}

.direction-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 30px;
  margin-bottom: 40px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.direction-card {
  background: #e0e7ff;
  border-radius: 12px;
  padding: 30px 25px;
  cursor: pointer;
  transition: all 0.2s;
  border: 2px solid transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-height: 280px;
  position: relative;
}

.direction-card:hover {
  border-color: #3b82f6;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
}

.direction-card.selected {
  border-color: #3b82f6;
  background: #dbeafe;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
}

.direction-icon {
  margin-bottom: 20px;
  color: #374151;
  display: flex;
  align-items: center;
  justify-content: center;
}

.direction-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 20px;
}

.direction-title {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 10px 0;
}

.direction-subtitle {
  font-size: 16px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 15px;
  line-height: 1.4;
}

.direction-description {
  font-size: 14px;
  color: #4b5563;
  margin: 0 0 10px 0;
  line-height: 1.5;
}

.direction-use-case {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
  font-style: italic;
  line-height: 1.5;
}

.direction-radio {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}

.radio-input {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: #3b82f6;
}

.customize-section {
  text-align: center;
  margin-bottom: 40px;
}

.customize-link {
  background: none;
  border: none;
  color: #3b82f6;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;
  margin-bottom: 10px;
  padding: 0;
}

.customize-link:hover {
  color: #2563eb;
}

.settings-note {
  font-size: 14px;
  color: #6b7280;
  margin: 10px 0 0 0;
}

.actions-section {
  display: flex;
  justify-content: center;
  gap: 16px;
  max-width: 1200px;
  margin: 0 auto;
}

.back-button,
.continue-button {
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.back-button {
  background: white;
  color: #6b7280;
  border: 1px solid #d1d5db;
}

.back-button:hover {
  background: #f9fafb;
  border-color: #9ca3af;
}

.continue-button {
  background: #3b82f6;
  color: white;
  border: 1px solid #3b82f6;
}

.continue-button:hover:not(:disabled) {
  background: #2563eb;
  border-color: #2563eb;
}

.continue-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #9ca3af;
  border-color: #9ca3af;
}

/* Special styling for bidirectional card */
.direction-card:first-child .direction-icon {
  color: #059669;
}

.direction-card:first-child.selected {
  background: #d1fae5;
  border-color: #059669;
}

.direction-card:first-child:hover {
  border-color: #059669;
  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.15);
}

@media (max-width: 768px) {
  .sync-direction {
    padding: 20px;
  }

  .direction-options {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .direction-card {
    padding: 25px 20px;
    min-height: 250px;
  }

  .actions-section {
    flex-direction: column;
  }

  .back-button,
  .continue-button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Connector/components/SyncDirection.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,2CAA2C;AAC3C;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".sync-direction {\n  min-height: calc(100vh - 140px);\n  padding: 40px;\n  background: #f8fafc;\n}\n\n.sync-direction-header {\n  text-align: center;\n  margin-bottom: 50px;\n}\n\n.sync-direction-header h1 {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 12px;\n}\n\n.sync-direction-header p {\n  font-size: 16px;\n  color: #6b7280;\n  margin-bottom: 8px;\n  line-height: 1.6;\n}\n\n.direction-options {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 30px;\n  margin-bottom: 40px;\n  max-width: 1200px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.direction-card {\n  background: #e0e7ff;\n  border-radius: 12px;\n  padding: 30px 25px;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: 2px solid transparent;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  min-height: 280px;\n  position: relative;\n}\n\n.direction-card:hover {\n  border-color: #3b82f6;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);\n}\n\n.direction-card.selected {\n  border-color: #3b82f6;\n  background: #dbeafe;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);\n}\n\n.direction-icon {\n  margin-bottom: 20px;\n  color: #374151;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.direction-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n.direction-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0 0 10px 0;\n}\n\n.direction-subtitle {\n  font-size: 16px;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 15px;\n  line-height: 1.4;\n}\n\n.direction-description {\n  font-size: 14px;\n  color: #4b5563;\n  margin: 0 0 10px 0;\n  line-height: 1.5;\n}\n\n.direction-use-case {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0;\n  font-style: italic;\n  line-height: 1.5;\n}\n\n.direction-radio {\n  position: absolute;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.radio-input {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  accent-color: #3b82f6;\n}\n\n.customize-section {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.customize-link {\n  background: none;\n  border: none;\n  color: #3b82f6;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: underline;\n  margin-bottom: 10px;\n  padding: 0;\n}\n\n.customize-link:hover {\n  color: #2563eb;\n}\n\n.settings-note {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 10px 0 0 0;\n}\n\n.actions-section {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.back-button,\n.continue-button {\n  padding: 12px 32px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.back-button {\n  background: white;\n  color: #6b7280;\n  border: 1px solid #d1d5db;\n}\n\n.back-button:hover {\n  background: #f9fafb;\n  border-color: #9ca3af;\n}\n\n.continue-button {\n  background: #3b82f6;\n  color: white;\n  border: 1px solid #3b82f6;\n}\n\n.continue-button:hover:not(:disabled) {\n  background: #2563eb;\n  border-color: #2563eb;\n}\n\n.continue-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background: #9ca3af;\n  border-color: #9ca3af;\n}\n\n/* Special styling for bidirectional card */\n.direction-card:first-child .direction-icon {\n  color: #059669;\n}\n\n.direction-card:first-child.selected {\n  background: #d1fae5;\n  border-color: #059669;\n}\n\n.direction-card:first-child:hover {\n  border-color: #059669;\n  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.15);\n}\n\n@media (max-width: 768px) {\n  .sync-direction {\n    padding: 20px;\n  }\n\n  .direction-options {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .direction-card {\n    padding: 25px 20px;\n    min-height: 250px;\n  }\n\n  .actions-section {\n    flex-direction: column;\n  }\n\n  .back-button,\n  .continue-button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
